import type { JiraTopBanner } from '@post-office/placement-create-pipeline/pipes';

import {
	createClientPipeline,
	initializeHydrateExample,
} from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '../../..';

import { type RequestContext } from '@post-office/shared-contracts/shared-request-middleware-context';
import { type JSX } from 'react/jsx-runtime';

export type HydrationResult = {
	readMoreLink: string;
};

type Pipe = JiraTopBanner<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <
	U extends (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null,
>(
	render: U,
) => (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null =
	clientPipeline.createRender;
export const createHydrateExample: (
	hydrateExample: (
		requestContext: Partial<RequestContext>,
		placementContext: {
			[x: string]: never;
		},
		messageContext: {
			testProp: string;
			testObjProp: {
				testObjPropKey: string;
			};
			testArrayProp: number[];
		},
	) => HydrationResult,
	config?:
		| {
				requestContext?: Partial<RequestContext>;
		  }
		| undefined,
) => (
	requestContext: Partial<RequestContext>,
	placementContext: {
		[x: string]: never;
	},
	messageContext: {
		testProp: string;
		testObjProp: {
			testObjPropKey: string;
		};
		testArrayProp: number[];
	} & {
		messageInstanceId: string;
		eventTime: string;
	},
) => Omit<HydrationResult, 'postOffice'> = initializeHydrateExample<Pipe>();
